<template>
  <div class="hello">
    <div class="container-fluid" style="margin-left:0;padding-left:1.5rem;width:100%">
      <header class="d-flex justify-content-between align-items-center py-3 border-bottom">
      <!-- 왼쪽 정렬: 김프모아 -->
      <a href="#" class="navbar-brand d-flex align-items-center text-dark text-decoration-none">
        <h3 class="mb-0" style="color:#60666b;font-family: 'Noto Sans KR', sans-serif; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);font-weight: bold;">김프모아</h3>
      </a>

    <!-- 모바일에서는 햄버거 메뉴로 숨겨지고 데스크탑에서는 오른쪽에 메뉴 배치 -->
    <ul class="nav nav-pills d-none d-md-flex">
      <li class="nav-item"><a href="#" class="nav-link active" aria-current="page">HOME</a></li>
      <!--
      <li class="nav-item"><a href="/Info" class="nav-link" aria-current="page">Investment Overview</a></li>
      -->
      <li class="nav-item"><a href="/SystemSetup" class="nav-link" aria-current="page" style="color: #60666b;">SETTING</a></li>
      <li class="nav-item"><a href="/Guide" class="nav-link" aria-current="page" style="color: #60666b;">GUIDE</a></li>
    </ul>

    <!-- 모바일 햄버거 메뉴 -->
    <button class="navbar-toggler d-md-none ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <!--
     <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    -->
    

    <!--
        <ul class="nav nav-pills">
          <li class="nav-item"><a href="#" class="nav-link active" aria-current="page">코인</a></li>
          <li class="nav-item"><a href="#" class="nav-link" aria-current="page">미국주식</a></li>
          
          <li class="nav-item"><a href="#" class="nav-link">설정</a></li>
          
          <li class="nav-item"><a href="#" class="nav-link" style="color:#60666b">About</a></li>
          
        </ul>
        -->
      </header>
      <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav" style="text-align: right;">
        <li class="nav-item">
          <a class="nav-link mob_active" aria-current="page" href="#">HOME</a>
        </li>
        <li class="nav-item" style="color:#60666b">
          <a class="nav-link" href="/SystemSetup" style="color:#60666b">SETTING</a>
        </li>
        <li class="nav-item" style="color:#60666b">
          <a class="nav-link" href="/Guide" style="color:#60666b">GUIDE</a>
        </li>
        <!--
        <li class="nav-item">
          <a class="nav-link disabled">Disabled</a>
        </li>
        -->
      </ul>
    </div>
    </div>
     <div class="info-bar" style="display: flex; align-items: center; gap: 20px;">
        <span style="margin-left:1.5rem;font-size:0.8rem;">
          $ {{formattedNumbers(Number(usdkrw))}}</span>
        <span style="display: flex; align-items: center;font-size:0.8rem;">
          <img :src="require(`@/assets/coinlogo/USDT.png`)" width="18px" style="margin-right:5px">
          {{formattedNumbers(Number(usdtkrw))}}</span>
    </div>
    <div class="row" style="margin-right:0px">
      <!--지수-->
      <div class="col-sm-8 border">
      
      <!--코인-->
      <div class="col-sm-12" style="padding-top:0.5rem;padding-left:0.5rem;margin-top:1rem;">
        
  


        <div class="controls" style="text-align: right;">
          <button  class="btn minus" @click="decreaseFontSize">-</button>
          <button class="btn plus" @click="increaseFontSize">+</button>
        </div>
        <div class="btn-group btn-group-lg w-100" style="padding:0 0.5rem 0 0.5rem;" role="group" aria-label="Basic outlined example">
          <button type="button" @click="coinButton('1')" :class="['btn btn-outline-dark w-50', { active: coinButton1 }]">즐겨찾기</button>
          <button type="button" @click="coinButton('2')" :class="['btn btn-outline-dark w-50', { active: coinButton2 }]">전체보기</button>
        </div>
        <table class="table table-striped table-hover cursor-pointer" style="table-layout: fixed;">
           <colgroup>
            <col style="width: 3%;" />
            <col style="width: auto;" />
            <col style="width: 17%;" />
            <col style="width: 22%;" />
            <col style="width: 10%;" />
            <col style="width: auto;" />
            <col style="width: 10%;" />
          </colgroup>
          <thead>
            <tr>
              <th scope="col" colspan="7">
                <div class="input-group">
                <input class="form-control index-search" placeholder="검색" v-model="searchCoinValue">
                </div>
              </th>
              <!--
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              -->
            </tr>
            <tr style="font-size:0.8rem;">
              <th></th>
              <th class="p0" >코인</th>
              <th class="p0" @click="toggleSort('binancePrice')">바이낸스 {{ sortKey === 'binancePrice' ? (sortOrder === 'asc' ? '⬆' : '⬇') : '' }}</th>
              <th class="p0" @click="toggleSort('trade_price')">업비트{{ sortKey === 'trade_price' ? (sortOrder === 'asc' ? '⬆' : '⬇') : '' }}</th>
              <th class="p0" @click="toggleSort('signed_change_rate')">변동{{ sortKey === 'signed_change_rate' ? (sortOrder === 'asc' ? '⬆' : '⬇') : '' }}</th>
              <th class="p0" @click="toggleSort('acc_trade_price_24h')">거래량{{ sortKey === 'acc_trade_price_24h' ? (sortOrder === 'asc' ? '⬆' : '⬇') : '' }}</th>
              <th class="p0" @click="toggleSort('kimp')">김프{{ sortKey === 'kimp' ? (sortOrder === 'asc' ? '⬆' : '⬇') : '' }}</th>
            </tr>
          </thead>
          <tbody v-if="coinButton1">
            <!--
            <tr v-for="(item,index) in coins.value" :key="index"
            :id="item.code" v-show="getCookies(item.code) === 'Y'">
            
            <tr>
              <th scope="row" colspan="7">
                <div>
                  <table style="width:100%;border-collapse: collapse;">
                    <tr>
                      <td @click="selectChartBong('1')" :class="{'bongStyle': true, 'bongSelect': selectBong === '1'}">1분</td>
                      <td @click="selectChartBong('5')" :class="{'bongStyle': true, 'bongSelect': selectBong === '5'}">5분</td>
                      <td @click="selectChartBong('15')" :class="{'bongStyle': true, 'bongSelect': selectBong === '15'}">15분</td>
                      <td @click="selectChartBong('1H')" :class="{'bongStyle': true, 'bongSelect': selectBong === '1H'}">1시간</td>
                      <td @click="selectChartBong('4H')" :class="{'bongStyle': true, 'bongSelect': selectBong === '4H'}">4시간</td>
                      <td @click="selectChartBong('1D')" :class="{'bongStyle': true, 'bongSelect': selectBong === '1D'}">1일</td>
                      <td @click="selectChartBong('1W')" :class="{'bongStyle': true, 'bongSelect': selectBong === '1W'}">1주</td>
                      <td @click="selectChartBong('1M')" :class="{'bongStyle': true, 'bongSelect': selectBong === '1M'}">1달</td>
                    </tr>
                  </table>
                </div>
              </th>
            </tr>
            -->
            <tr v-for="(item,index) in filteredCoins" :key="index"
            :id="item.code" v-show="isCoinRowVisible(item.code)">
              <th scope="row" class="p0" @click="selectCoinFavorite($event)">
                <span :id="`${item.code}_N`" v-show="getCookies(item.code)!=='Y'">★</span>
                <span :id="`${item.code}_Y`" v-show="getCookies(item.code)==='Y'">★</span>
              </th>
              
              <td class="align-left p0" @click="selectCoinChart($event)"><img :src="getImageUrl(item.code ? item.code.replace('KRW-','') : '')" style="width:20px;height:20px;margin:0 5px 0 5px"> {{item.code ? item.code.replace('KRW-','') : ''}}</td>
              <td class="align-right p0" @click="selectCoinChart($event)">{{formattedNumbers(parseFloat(item.binancePrice))}}</td>
              <td class="align-right p0" @click="selectCoinChart($event)">
                {{item.trade_price ? item.trade_price.toLocaleString() : ''}}원
              </td>
              <td class="align-right p0" :style="{ color: getColor(item.signed_change_rate) }" @click="selectCoinChart($event)">{{formatPercentage(item.signed_change_rate)}}%</td>
              <td class="align-right p0" @click="selectCoinChart($event)">{{formatToTrillion(item.acc_trade_price_24h)}}</td>
              <td v-if="item.binancePrice" class="align-right p0" :style="{ color: getColor(formatKimpPercentage(item.trade_price,item.binancePrice,usdkrw)) }" @click="selectCoinChart($event)">{{formatKimpPercentage(item.trade_price,item.binancePrice,usdkrw)}}%</td>
              <td v-if="!item.binancePrice" class="align-right p0" :style="{ color: getColor(formatKimpPercentage(item.trade_price,item.binancePrice,usdkrw)) }" @click="selectCoinChart($event)">{{formatKimpPercentage(item.trade_price,item.binancePrice,usdkrw)}}</td>
              
            </tr>
            <!--
            <tr  :key="'expanded-' + index">
              <th scope="row" colspan="7">
                <div>
                  <table style="width:100%;border-collapse: collapse;">
                    <tr>
                      <td @click="selectChartBong('1')" :class="{'bongStyle': true, 'bongSelect': selectBong === '1'}">1분</td>
                      <td @click="selectChartBong('5')" :class="{'bongStyle': true, 'bongSelect': selectBong === '5'}">5분</td>
                      <td @click="selectChartBong('15')" :class="{'bongStyle': true, 'bongSelect': selectBong === '15'}">15분</td>
                      <td @click="selectChartBong('1H')" :class="{'bongStyle': true, 'bongSelect': selectBong === '1H'}">1시간</td>
                      <td @click="selectChartBong('4H')" :class="{'bongStyle': true, 'bongSelect': selectBong === '4H'}">4시간</td>
                      <td @click="selectChartBong('1D')" :class="{'bongStyle': true, 'bongSelect': selectBong === '1D'}">1일</td>
                      <td @click="selectChartBong('1W')" :class="{'bongStyle': true, 'bongSelect': selectBong === '1W'}">1주</td>
                      <td @click="selectChartBong('1M')" :class="{'bongStyle': true, 'bongSelect': selectBong === '1M'}">1달</td>
                    </tr>
                  </table>
                </div>
              </th>
            </tr>
            -->
          </tbody>
          <tbody v-if="coinButton2">
            <tr v-for="(item,index) in sortedCoins" :key="index"
            :id="item.code" v-show="isCoinRowVisible(item.code)">
              <th scope="row" class="p0" @click="selectCoinFavorite($event)">
                <span :id="`${item.code}_N`" v-show="getCookies(item.code)!=='Y'">☆</span>
                <span :id="`${item.code}_Y`" v-show="getCookies(item.code)==='Y'">★</span>
              </th>
              
              <td class="align-left p0" @click="selectCoinChart($event)"><img :src="getImageUrl(item.code ? item.code.replace('KRW-','') : '')" style="width:20px;height:20px;margin:0 5px 0 5px">{{item.code ? item.code.replace('KRW-',''): ''}}</td>
              <td class="align-right p0" @click="selectCoinChart($event)">{{formattedNumbers(parseFloat(item.binancePrice))}}</td>
              <td class="align-right p0" @click="selectCoinChart($event)">
                {{item.trade_price ? item.trade_price.toLocaleString(): ''}}원
              </td>
              <td class="align-right p0" :style="{ color: getColor(item.signed_change_rate) }" @click="selectCoinChart($event)">{{formatPercentage(item.signed_change_rate)}}%</td>
              <td class="align-right p0" @click="selectCoinChart($event)">{{formatToTrillion(item.acc_trade_price_24h)}}</td>
              <td v-if="item.binancePrice" class="align-right p0" :style="{ color: getColor(formatKimpPercentage(item.trade_price,item.binancePrice,usdkrw)) }" @click="selectCoinChart($event)">{{formatKimpPercentage(item.trade_price,item.binancePrice,usdkrw)}}%</td>
              <td v-if="!item.binancePrice" class="align-right p0" :style="{ color: getColor(formatKimpPercentage(item.trade_price,item.binancePrice,usdkrw)) }" @click="selectCoinChart($event)">{{formatKimpPercentage(item.trade_price,item.binancePrice,usdkrw)}}</td>
              
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-12" style="padding-top:0.5rem;padding-left:0.5rem;margin-top:3rem">
        <div class="btn-group btn-group-lg w-100" style="padding:0 0.5rem 0 0.5rem;" role="group" aria-label="Basic outlined example">
          <button type="button" @click="indexButton('1')" :class="['btn btn-outline-dark w-50', { active: indexButton1 }]">즐겨찾기</button>
          <button type="button" @click="indexButton('2')" :class="['btn btn-outline-dark w-50', { active: indexButton2 }]">전체보기</button>
        </div>
        <table class="table table-striped table-hover cursor-pointer">
          <thead>
            <tr>
              <th scope="col" colspan="4">
                <div class="input-group">
                <input class="form-control index-search" placeholder="검색" v-model="searchIndexValue">
                </div>
              </th>
              <!--
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              -->
            </tr>
          </thead>
          <tbody v-if="indexButton1">
            <tr v-for="(item,index) in filteredIndexChartList" :key="index"
            :id="item.id" v-show="isIndexRowVisible(item.name)">
              <th scope="row" @click="selectIndexFavorite($event)">
                <span :id="`${item.id}_N`" v-show="getCookies(item.id)!=='Y'">★</span>
                <span :id="`${item.id}_Y`" v-show="getCookies(item.id)==='Y'">★</span>
              </th>
              <td class="align-left" @click="selectIndexChart($event)"  colspan="3">{{item.name}}</td>
            </tr>
          </tbody>
          <tbody v-if="indexButton2">
            <tr v-for="(item,index) in indexChartList" :key="index"
            :id="item.id" v-show="isIndexRowVisible(item.name)">
              <th scope="row" @click="selectIndexFavorite($event)">
                <span :id="`${item.id}_N`" v-show="getCookies(item.id)!=='Y'">☆</span>
                <span :id="`${item.id}_Y`" v-show="getCookies(item.id)==='Y'">★</span>
              </th>
              <td v-if="item.cutomChart==='Y'"
                  class="align-left d-flex justify-content-between" @click="selectIndexChart($event)"  colspan="3">{{item.name}}
                 <button 
                 @click="deleteChart($event)" class="btn btn-danger btn-xs ms-auto">삭제</button>
              </td>
              <td v-else
                 class="align-left" @click="selectIndexChart($event)"  colspan="3">{{item.name}}
              </td>
            </tr>
          </tbody>
        </table>

          <!-- 심볼 & 차트명 추가 UI -->
            <div class="input-group mt-3">
              <input v-model="newSymbol" type="text" class="form-control" placeholder="심볼(ex: BTCUSD)">
              <input v-model="newChartName" type="text" class="form-control" placeholder="차트명 입력">
              <button class="btn btn-secondary" @click="addChart">추가</button>
            </div>
            <!-- 안내 메시지 추가 -->
            <div class="mt-2 text-muted" style="text-align:left;margin-bottom:2rem;">
              <small>*트레이딩뷰에서 조회 가능한 정확한 심볼을 입력해주세요.</small>
            </div>

            <!-- 가이드 이동 버튼 추가 -->
            <!--
            <div class="mt-3">
              <a href="https://www.tradingview.com/symbols/" style="color:white" target="_blank" class="btn btn-secondary">
                심볼 조회 가이드
              </a>
            </div>
            -->




<!-- 경제 캘린더 토글 버튼 -->
<div  style="margin-bottom:30px;">
  <div class="text-center mt-3">
    <button class="btn btn-outline-secondary w-100" @click="toggleCalendar" style="border: 2px solid #60666b;">
      인베스팅닷컴 경제 캘린더 펼쳐보기(클릭)
    </button>
  </div>

  <!-- Investing.com 경제 캘린더 -->
  <div v-if="showCalendar" class="mt-3" style="overflow-x: auto; padding: 10px; border: 1px solid #ccc; border-radius: 10px; margin-top: 20px;">
    <iframe src="https://sslecal2.investing.com?columns=exc_flags,exc_currency,exc_importance,exc_actual,exc_forecast,exc_previous&features=datepicker,timezone&countries=110,43,17,42,5,178,32,12,26,36,4,72,10,14,48,35,37,6,122,41,22,11,25,39&calType=week&timeZone=88&lang=18"
    width="650" height="400" frameborder="0" allowtransparency="true" marginwidth="0" marginheight="0"></iframe>
    <div class="poweredBy" style="font-family: Arial, Helvetica, sans-serif;">
      <span style="font-size: 11px;color: #333333;text-decoration: none;">
         <a href="https://kr.Investing.com/" rel="nofollow" target="_blank" style="font-size: 11px;color: #06529D; font-weight: bold;" class="underline_link">
         Investing.com 한국어</a>.</span></div>
  </div>
</div>

      </div>
      </div>
       <div class="col-sm-4">
        <div class="guide-section sticky-top" style="position:sticky; top:70px;z-index:1000;padding-left:1rem;">
          <!--
          <div class="card mb-3">
            <img src="#" class="card-img-top" alt="광고 배너">
            <div class="card-body text-center">
              <p class="card-text">광고 배너 영역</p>
            </div>
          </div>
          -->
          <RealTimeChat :coinValues="coins"/>
          <div class="border rounded p-4 mb-4" style="background-color: #f8f9fa; border-color: #ccc;">
            <h3 class="mb-4">김프모아 가이드</h3>
            <p>김프모아 가이드를 확인하고 더욱 편리하게 이용하세요</p>
            <!-- 버튼 -->
            <a href="/Guide" style="color:white" class="btn btn-secondary btn-lgbtn-lg">가이드 페이지로 이동</a>
          </div>

          <!--
          <div class="card">
            <div class="card-body text-center">
              <button class="btn btn-primary"></button>
            </div>
          </div>
          -->
        </div>
      </div>
      
    </div>
    <div class="bg-dark text-white text-center py-1" style="font-size:0.8rem">
     Copyright © 2025 kimpmoa. All Rights Reserved.
    <br>
    <a href="/PrivacyPolicy" class="text-white mx-2" style="font-size:0.7rem">개인정보처리방침</a> |
    <a href="/TermsOfService" class="text-white mx-2" style="font-size:0.7rem">이용약관</a> |
    <a href="/about" class="text-white mx-2" style="font-size:0.7rem">사이트소개</a>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue';
import Cookies from "js-cookie";
import axios from "axios";
import RealTimeChat from './RealTimeChat.vue'; // Chat.vue를 import

export default {
  name: 'HelloWorld',
   components: {
    RealTimeChat, // Chat 컴포넌트 등록
  },
  data() {
    return {
      showCalendar: false,
      fontSize: 0.75,
      newSymbol: '',
      newChartName: '',
      firstVisit: '',
      currentChart: '',
      sortKey: Cookies.get('sortKey'),
      sortOrder: Cookies.get('sortOrder'),
      usdkrw: '',
      //usdtkrw: '',
      isShowChart: false,
      currentShowChart: '',
      indexButton1: true,
      indexButton2: false,
      coinButton1: true,
      coinButton2: false,
      symbol: '',
      searchIndexValue: '',
      searchCoinValue: '',
      
      message: 'Hello, Vue!',
      indexChartList: [
        { id: '(BINANCE:BTCUSD/BINANCE:BTCUSD*BITHUMB:BTCKRW/FX_IDC:USDKRW-BINANCE:BTCUSD)*100/BINANCE:BTCUSD_chart', name: "김프 차트 보기", showYN: "" },
        { id: 'BTC.D_chart', name: "비트코인 도미넌스 차트보기", showYN: "" },
        { id: 'ETH.D_chart', name: "이더리움 도미넌스 차트보기", showYN: "" },
        { id: 'USDT.D_chart', name: "테더 도미넌스 차트보기", showYN: "" },
        { id: 'BTC1!_chart', name: "비트코인 CME차트 보기", showYN: "" },
        { id: 'TOTAL_chart', name: "토탈(전체 코인 시가총액) 차트보기", showYN: "" },
        { id: 'TOTAL2_chart', name: "토탈2(비트코인 제외 시가총액) 차트보기", showYN: "" },
        { id: 'TOTAL3_chart', name: "토탈3(비트코인,이더리움 제외 시가총액) 차트보기", showYN: "" },
        { id: 'XAUUSD_chart', name: "금 차트보기", showYN: "" },
        { id: 'XAGUSD_chart', name: "은 차트보기", showYN: "" },
        { id: 'USOIL_chart', name: "WTI오일 차트보기", showYN: "" },
        { id: 'NAS100USD_chart', name: "나스닥 선물 차트보기", showYN: "" },
        { id: 'VIX_chart', name: "VIX 차트보기", showYN: "" },

      
      ],
      ws: null,
      data: null,
      binance_ws: null,
      binance_data: null,
      coins: [],
      symbols: [],
      coinChartList: [],
      selectBong: ''
    };
  },
  watch: {
  fontSize(newSize) {
     document.documentElement.style.setProperty("--font-size", `${newSize}rem`);
    }
  },
  computed: {
    filteredIndexChartList() {
      return this.indexChartList.filter(chart => chart.showYN === 'Y');
    },
    sortedCoins() {
      if(this.coins && this.coins.value){
        return [...this.coins.value].sort((a, b) => {
          if (!this.sortKey) return 0; // 정렬 키가 없으면 정렬하지 않음

          if (this.sortKey === 'kimp'){
            let valueA = this.formatKimpPercentage(a.trade_price,a.binancePrice,1500) ;
            let valueB = this.formatKimpPercentage(b.trade_price,b.binancePrice,1500) ;

            let result = valueA - valueB;
            return this.sortOrder === "asc" ? result : -result;
          } else{
            let result = a[this.sortKey] - b[this.sortKey];
            return this.sortOrder === "asc" ? result : -result;
          }
        });
       }else{
        return []
       }
    },
    filteredCoins() {
      if(this.coins && this.coins.value){
        return this.coins.value.filter(coin => {
          if(coin.showYN !== 'undefined'){
            return this.getCookies(coin.code)==='Y'&& coin.showYN !=='N';
          }else{
            return this.getCookies(coin.code)==='Y';
          }
        })
        .sort((a, b) => {
          if (!this.sortKey) return 0; // 정렬 키가 없으면 정렬하지 않음

          if (this.sortKey === 'kimp'){
            let valueA = a.trade_price / a.binancePrice;
            let valueB = b.trade_price / b.binancePrice;

            let result = valueA - valueB;
            return this.sortOrder === "asc" ? result : -result;
          } else{
            let result = a[this.sortKey] - b[this.sortKey];
            return this.sortOrder === "asc" ? result : -result;
          }
        });
       }else{
        return []
       }
    },
    usdtkrw() {
      if(this.coins && this.coins.value){
        const usdtCoin = this.coins.value.find(item => item.code === "KRW-USDT");
        return usdtCoin ? usdtCoin.trade_price : '';
      }else{
        return '';
      }
    }
},
  methods : {
  toggleCalendar() {
    this.showCalendar = !this.showCalendar;
  },
  increaseFontSize()  {
    this.fontSize = parseFloat((this.fontSize + 0.05).toFixed(2));
    localStorage.setItem('fontSize', this.fontSize);
  },
  decreaseFontSize() {
    if (this.fontSize > 0.05) {
      this.fontSize = parseFloat((this.fontSize - 0.05).toFixed(2));
      localStorage.setItem('fontSize', this.fontSize);
    }
  },
  deleteChart(event){
    event.stopPropagation(); 
    const selectId = event.target.closest('tr').id;
    this.indexChartList = this.indexChartList.filter(chart => chart.id !== selectId);
    Cookies.remove('selectId');
    localStorage.setItem('indexChartList', JSON.stringify(this.indexChartList));

  },
  addChart(){
    if(!this.newSymbol){
      alert('심볼을 입력하세요');
      return;
    }
    if(!this.newChartName){
      alert('차트명을 입력하세요.');
      return;
    }
    const exists = this.indexChartList.some(chart => chart.id === this.newSymbol+'_chart');

    if (exists) {
      alert('이미 같은 심볼의 차트가 존재합니다.');
      return;
    }
    this.indexChartList.push({
      id: this.newSymbol+'_chart',
      name: this.newChartName,
      showYN: "Y",
      cutomChart: "Y",
    });
    Cookies.set(this.newSymbol+'_chart', "Y", { expires: 3650 });
    localStorage.setItem('indexChartList', JSON.stringify(this.indexChartList));

    this.initIndexChart();
    this.newSymbol = '';
    this.newChartName = '';
    
  },
  getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');

    return `${year}${month}${day}${hour}`;
  },
  getCurrentDateTimeMin() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minuteFirstDigit = Math.floor(now.getMinutes() / 10); // 분의 앞자리 숫자


    return `${year}${month}${day}${hour}${minuteFirstDigit}`;
  },
  selectChartBong(selectBong){
    Cookies.set('selectBong', selectBong, { expires: 3650 });
    this.selectBong = selectBong;
    this.initializeTradingView();
  },
   getImageUrl(imageName){
    try {
        // `require`를 사용하여 이미지 경로를 확인
         return require(`@/assets/coinlogo/${imageName}.png`) || require('@/assets/coinlogo/none.png');
       } catch (error) {
         // 이미지가 없으면 디폴트 이미지 반환
         return require('@/assets/coinlogo/none.png');
       }
    },
    toggleSort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc"; // 방향 변경
        Cookies.set('sortKey', this.sortKey, { expires: 3650 });
        Cookies.set('sortOrder', this.sortOrder, { expires: 3650 });
      } else {
        this.sortKey = key;
        this.sortOrder = "desc"; // 새로운 키 선택 시 기본 내림차순
        Cookies.set('sortKey', this.sortKey, { expires: 3650 });
        Cookies.set('sortOrder', this.sortOrder, { expires: 3650 });
      
      }
    },
    getColor(value){
      if (value >= 0) return "green";  // 양수 → 초록색
      if (value < 0) return "red";    // 음수 → 빨간색
    },
    formatToTrillion(number) {
      if (typeof number !== "number") return "";

      // 1조 단위로 변환
      const trillionPart = Math.floor(number / 1000000000000); // 1조 단위
      const billionPart = Math.floor((number % 1000000000000) / 100000000); // 나머지 1억 단위

      // 1조가 있으면 그 값을, 없으면 빈 문자열
      let formattedTrillion = trillionPart > 0 ? trillionPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "조" : "";

      // 1억 단위 값이 있으면 표시, 없으면 빈 문자열
      let formattedBillion = billionPart > 0 ? billionPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "억" : "";

      // 둘을 합쳐서 반환
      return formattedTrillion + (formattedBillion ? " " + formattedBillion : "");
    },
    formatKimpPercentage(trade_price,binancePrice,usdkrw){
      if(binancePrice){
        return this.formatPercentage((trade_price/(binancePrice*usdkrw))-1);
      }else{
        return '';
      }
    },
    setExchange(){
      this.getExchange();
      // 3초마다 환율을 가져와서 갱신
      setInterval(() => {
         this.getExchange();
      }, 1000*60*10); // 10분마다 갱신
    },
    getExchange(){
    try {
        ////////////////2025.02.26

      let dollarTime = localStorage.getItem('dollarTime');
      if(dollarTime === this.getCurrentDateTimeMin() && (localStorage.getItem('dollar') !== '' &&localStorage.getItem('dollar')!=='undefined')){
        this.usdkrw = localStorage.getItem('dollar');
      }else{
        
        axios.get("https://api1.kimpmoa.com/api/getKrwDollar").then((result) => {
          this.usdkrw = result.data[0][0];
          if(this.usdkrw !== '' && this.usdkrw !==null){
            localStorage.setItem('dollarTime',this.getCurrentDateTimeMin());
            localStorage.setItem('dollar',this.usdkrw);
          }
        });
      }
          
            /////////////
          

        } catch (error) {
          console.error('환율 정보를 가져오는 데 실패했습니다:', error);
        }
    },
    formattedNumbers(number) {
      if(number){
         let formatted;
        if (number >= 100) {
          // 100 이상일 때는 소수점 2자리
          formatted = number.toFixed(2);
          //return number.toFixed(2);
        } else if (number >= 10) {
          // 10 이상 100 미만일 때는 소수점 3자리
          formatted = number.toFixed(3);
          //return number.toFixed(3);
        } else if (number >= 1) {
          // 1 이상 10 미만일 때는 소수점 4자리
          formatted = number.toFixed(4);
          //return number.toFixed(4);
        } else {
          // 그 이하일 때는 소수점 4자리
          formatted = number.toFixed(4);
          //return number.toFixed(4);
        }
         // 정수 부분과 소수 부분 분리
        let [integerPart, decimalPart] = formatted.split(".");

        // 정수 부분에만 콤마 추가
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // 소수점 이하가 있으면 결합해서 반환, 없으면 정수만 반환
        return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
      }else{
        return '';
      }
    },
    formatPercentage(value) {
      return (value * 100).toFixed(2) ; // 100을 곱하고 소수점 1자리까지 표시
    },
    async getUpbitSymbol(){

      let newcoinsTime = localStorage.getItem('newcoinsTime');
      let newcoins;
      if(newcoinsTime === this.getCurrentDateTime() && (localStorage.getItem('newcoins') !== '' &&localStorage.getItem('newcoins')!=='undefined')){
        newcoins = JSON.parse(localStorage.getItem('newcoins'));
      }else{
        ////new코인으로 변경 2025.2.26
          await axios.get("https://api1.kimpmoa.com/api/getTicker").then((result) => {
            newcoins = result.data.filter((result) => {
            return result.market.indexOf("KRW-") != -1;
          }); // BTC마켓은 "BTC-" , USDT마켓은 "USDT-" 로 필터링

          //localStorage.setItem("coinlist", newcoins);
          
        });
         // 심볼을 가져올 변수를 만듬
        localStorage.setItem('newcoins', JSON.stringify(newcoins));
        localStorage.setItem('newcoinsTime', this.getCurrentDateTime());
      } 
      this.coins.value = newcoins;

      for (let i = 0; i < this.coins.value.length; i++) {
        this.symbols.push(this.coins.value[i].market);
      }

      this.connectWebSocket();
    },
     // WebSocket 연결 함수
    connectWebSocket() {
      // WebSocket URL (Upbit WebSocket API)
      const url = "wss://api.upbit.com/websocket/v1";
      const binance_url = 'wss://stream.binance.com:9443/stream?streams=!miniTicker@arr';
      //const binance_url = 'wss://stream.binance.com:443/ws/!ticker@arr';
      
      // WebSocket 연결 생성
      this.ws = new WebSocket(url);
      this.binance_ws = new WebSocket(binance_url);

      // WebSocket 연결 성공 시 처리
      this.ws.onopen = () => {

        // 요청할 구독 메시지 (Upbit API 구독 형식에 맞춰서)
        const requestData = [
          {
            ticket: "fsdfas"
          }, // 구독 요청 티켓
          { 
            type: "ticker", // 데이터 타입
            //codes: ["KRW-BTC", "KRW-ETH","KRW-WLD", "fjsj"], // 구독할 마켓 코드 (예시: KRW-BTC, KRW-ETH)
            codes: this.symbols ,
          },
        ];
        if (this.ws.readyState === WebSocket.OPEN) {
          console.log('open');
        }
        // WebSocket에 구독 메시지 전송
        this.ws.send(JSON.stringify(requestData));
      };
      // WebSocket에서 메시지 수신 시 처리
      this.ws.onmessage = async (event) => {
        // 수신된 데이터는 JSON 형식이므로, 이를 파싱하여 `data`에 저장
        this.data = JSON.parse(await event.data.text());

        const key = Object.keys(this.coins.value).find(
          (key) => this.coins.value[key].market == this.data.code
        ); //실시간 데이터를 덮어 씌울 데이터를 찾기위해 key 값 찾기
        
        if (this.coins.value[key].market === this. data.code) {

            this.coins.value[key] = Object.assign(this.coins.value[key], this.data);
            this.coins.value[key].code = this.data.code;
            this.coins.value[key].signed_change_rate = this.data.signed_change_rate;
            this.coins.value[key].acc_trade_price_24h = this.data.acc_trade_price_24h;
            this.coins.value[key].trade_price = this.data.trade_price;
            this.coinChartList = this.coins.value;
            /*
            const obj = {
              name: 'a',
              change: '1%',
              price: 1000
            };
             const index = this.coinChartList.findIndex(coin => coin.name === newCoin.name);

              if (index !== -1) {
                // 기존 값이 있으면 덮어쓰기
                this.coinChartList[index] = newCoin;
              } else {
                // 기존 값이 없으면 추가
                this.coinChartList.push(newCoin);
              }
              */

        } //실시간 데이터의 code와 기본데이터의 market이 같으면 덮어 씌움
      };

      // WebSocket 연결 종료 시 처리
      this.ws.onclose = () => {
        console.log("WebSocket 연결 종료");
      };

      // WebSocket 에러 발생 시 처리
      this.ws.onerror = (error) => {
        console.error("WebSocket 에러:", error);
        setTimeout(() => {
          this.connectWebSocket();
        }, 3000);        
      };
    //바이낸스
    this.binance_ws.onopen = () => {
        console.log("onopen");
      };
      // WebSocket에서 메시지 수신 시 처리

      this.binance_ws.onmessage = async (event) => {
        // 수신된 데이터는 JSON 형식이므로, 이를 파싱하여 `data`에 저장
        this.binance_data = JSON.parse(event.data);
        //s ETHBTC  c 현재 종ㄱ
  /*
        const key = Object.keys(this.coins.value).find((key) => {
            //this.coins.value[key].market == this.data.code;
            const coinSymbol = this.coins.value[key].market.replace('KRW-', '');
            // this.data.code에서 USDT로 끝나는지 확인하고 비교
            return this.data.s.endsWith('USDT') && this.data.s.includes(coinSymbol);
          }
        ); //실시간 데이터를 덮어 씌울 데이터를 찾기위해 key 값 찾기
        console.log(this. data.code);
*/
        this.binance_data.data.forEach(item => {
          if (item.s.endsWith('USDT')) {
            this.coins.value.forEach(item2 => {
              if(item2.market.replace('KRW-', '') === item.s.replace('USDT', '')){
                item2.binancePrice = item.c;
              }
            });
          }
        });
            /*
            const obj = {
              name: 'a',
              change: '1%',
              price: 1000
            };
             const index = this.coinChartList.findIndex(coin => coin.name === newCoin.name);

              if (index !== -1) {
                // 기존 값이 있으면 덮어쓰기
                this.coinChartList[index] = newCoin;
              } else {
                // 기존 값이 없으면 추가
                this.coinChartList.push(newCoin);
              }

        } //실시간 데이터의 code와 기본데이터의 market이 같으면 덮어 씌움
*/
      };

      // WebSocket 연결 종료 시 처리
      this.ws.onclose = () => {
        console.log("WebSocket 연결 종료");
      };

      // WebSocket 에러 발생 시 처리
      this.ws.onerror = (error) => {
        console.error("WebSocket 에러:", error);
         setTimeout(() => {
          this.connectWebSocket();
        }, 3000);  
      };  
    },
    initIndexChart(){
      for(let i=0;i<this.indexChartList.length;i++){
        if(Cookies.get(this.indexChartList[i].id) === 'Y'){
          this.indexChartList[i].showYN = 'Y';
        }else{
          this.indexChartList[i].showYN = 'N';
        }
      }
      this.filteredIndexChartList = this.indexChartList.filter(chart => chart.showYN === 'Y');

    },
     initCoinChart(){
      for(let i=0;i<this.coins.value.length;i++){
        if(Cookies.get(this.coins.value[i].code) === 'Y'){
          this.coins.value[i].showYN = 'Y';
        }else{
          this.coins.value[i].showYN = 'N';
        }
      }
      //this.filteredCoins = this.coins.value.filter(coin => {
      //  return this.getCookies(coin.code) === 'Y'
      //  }
      //);
    },
    isIndexRowVisible(name){
      return this.searchIndexValue.toUpperCase().split('').every(char => name.includes(char));
    },
    isCoinRowVisible(name){
      //return this.searchCoinValue.toUpperCase().split('').every(char => name.includes(char));
      if(name){
       const regex = new RegExp(`.*${this.searchCoinValue.toUpperCase()}.*`, 'i');
       return regex.test(name.toUpperCase());
      }else{
        return true;
      }
    },
    indexButton(i){
      if(i === '1'){
        if(!this.indexButton1){
          this.indexButton1=true;
          this.indexButton2=false;
        }
      }else{
        if(!this.indexButton2){
          this.indexButton1=false;
          this.indexButton2=true;
        }
      }
    },
    
    coinButton(i){
      if(i === '1'){
        if(!this.coinButton1){
          this.coinButton1=true;
          this.coinButton2=false;
        }
      }else{
        if(!this.coinButton2){
          this.coinButton1=false;
          this.coinButton2=true;
        }
      }
    },
    selectIndexFavorite(event){
      const selectId = event.target.closest('tr').id;
      if(Cookies.get(selectId) === 'Y'){
         Cookies.set(selectId, "N", { expires: 3650 }); // 10 years0

          const chart = this.indexChartList.find(item => item.id === selectId);
          if (chart) {
            // showYN 값 변경 ("" ↔ "Y" 방식으로 예시)
            chart.showYN = "N";
            // 로컬스토리지에 변경된 배열 저장
            localStorage.setItem('indexChartList', JSON.stringify(this.indexChartList));
          }


         if(this.firstVisit !== 'N'){
          Cookies.set('firstVisit', "N", { expires: 3650 });
         }
         const id_N = document.getElementById(selectId+'_N');
         id_N.style.display="block";
         const id_Y = document.getElementById(selectId+'_Y');
         id_Y.style.display="none";
      }else{
        Cookies.set(selectId, "Y", { expires: 3650 }); // 10 years
        const chart = this.indexChartList.find(item => item.id === selectId);
        if (chart) {
          // showYN 값 변경 ("" ↔ "Y" 방식으로 예시)
          chart.showYN = "Y";
          // 로컬스토리지에 변경된 배열 저장
          localStorage.setItem('indexChartList', JSON.stringify(this.indexChartList));
        }
        if(this.firstVisit !== 'N'){
          Cookies.set('firstVisit', "N", { expires: 3650 });
         }
        const id_N = document.getElementById(selectId+'_N');
        id_N.style.display="none";
        const id_Y = document.getElementById(selectId+'_Y');
        id_Y.style.display="block";
      }
      this.initIndexChart();
    },
    selectCoinFavorite(event){
      const selectId = event.target.closest('tr').id;
      if(Cookies.get(selectId) === 'Y'){
         Cookies.set(selectId, "N", { expires: 3650 }); // 10 years0
         if(this.firstVisit !== 'N'){
          Cookies.set('firstVisit', "N", { expires: 3650 });
         }
         const id_N = document.getElementById(selectId+'_N');
         id_N.style.display="block";
         const id_Y = document.getElementById(selectId+'_Y');
         id_Y.style.display="none";
      }else{
        Cookies.set(selectId, "Y", { expires: 3650 }); // 10 years
        if(this.firstVisit !== 'N'){
          Cookies.set('firstVisit', "N", { expires: 3650 });
         }
        const id_N = document.getElementById(selectId+'_N');
        id_N.style.display="none";
        const id_Y = document.getElementById(selectId+'_Y');
        id_Y.style.display="block";
      }
      this.initCoinChart();
    },
    getCookies(id){
      if(Cookies.get(id)) {
        return Cookies.get(id);
      } else{
        return 'N'
      }
    },
    selectIndexChart(event) {
      const selectId = event.target.closest('tr').id;
      
      if(selectId === this.currentShowChart){
        const trElement = document.getElementById('showChart');
    
        // 해당 <tr> 요소가 있으면 삭제
        if (trElement) {
          trElement.remove();
        }
        const trBong = document.getElementById('showBong');
        if (trBong) {
          trBong.remove();
        }
        this.currentShowChart = '';
        return; 
      }
      const trElement = document.getElementById('showChart');
  
      // 해당 <tr> 요소가 있으면 삭제
      if (trElement) {
        trElement.remove();
      }
      const trBong = document.getElementById('showBong');
        if (trBong) {
          trBong.remove();
        }
      this.currentShowChart = '';

      let selectSymbol = selectId.replace('_chart','');
      const referenceTr = document.getElementById(selectId);
      // 새로운 <tr> 요소 생성
      let a = `<tr id="showBong">
              <th scope="row" colspan="7">
                <div>
                  <table style="width:100%;border-collapse: collapse;">
                    <tr>
                      <td id="bong1" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">1분</td>
                      <td id="bong5" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">5분</td>
                      <td id="bong15" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">15분</td>
                      <td id="bong1H" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">1시간</td>
                      <td id="bong4H" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">4시간</td>
                      <td id="bong1D" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">1일</td>
                      <td id="bong1W" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">1주</td>
                      <td id="bong1M" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">1달</td>
                    </tr>
                  </table>
                </div>
              </th>
            </tr>`;
      const newTr = a+'<tr id="showChart"><th scope="row" colspan="4"><div id="tradingviewContainer"></div></th></tr>';
      this.symbol = selectSymbol;
      this.initializeTradingView();
      // id="a" 뒤에 새로운 <tr> 추가
      referenceTr.insertAdjacentHTML('afterend', newTr);
      this.$nextTick(() => {
        var element = document.getElementById('bong'+this.selectBong);
        element.style.backgroundColor = '#A6A6A6';
        this.$forceUpdate();  // Vue의 상태를 강제로 갱신
         const newRow = this.$el.querySelector('#bong1');
          newRow.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
            Cookies.set('selectBong', '1', { expires: 3650 });
            this.selectBong = '1';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow2 = this.$el.querySelector('#bong5');
          newRow2.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
            Cookies.set('selectBong', '5', { expires: 3650 });
            this.selectBong = '5';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow3 = this.$el.querySelector('#bong15');
          newRow3.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
            Cookies.set('selectBong', '15', { expires: 3650 });
            this.selectBong = '15';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow4 = this.$el.querySelector('#bong1H');
          newRow4.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
            Cookies.set('selectBong', '1H', { expires: 3650 });
            this.selectBong = '1H';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow5 = this.$el.querySelector('#bong4H');
          newRow5.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
            Cookies.set('selectBong', '4H', { expires: 3650 });
            this.selectBong = '4H';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow6 = this.$el.querySelector('#bong1D');
          newRow6.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
             Cookies.set('selectBong', '1D', { expires: 3650 });
            this.selectBong = '1D';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow7 = this.$el.querySelector('#bong1W');
          newRow7.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
             Cookies.set('selectBong', '1W', { expires: 3650 });
            this.selectBong = '1W';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow8 = this.$el.querySelector('#bong1M');
          newRow8.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
              Cookies.set('selectBong', '1M', { expires: 3650 });
            this.selectBong = '1M';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
       });
      this.currentShowChart = selectId;
    },
    selectCoinChart(event) {
      const selectId = event.target.closest('tr').id;
      
      if(selectId === this.currentShowChart){
        const trElement = document.getElementById('showChart');
    
        // 해당 <tr> 요소가 있으면 삭제
        if (trElement) {
          trElement.remove();
        }
        const trBong = document.getElementById('showBong');
        if (trBong) {
          trBong.remove();
        }
        this.currentShowChart = '';
        return; 
      }
      const trElement = document.getElementById('showChart');
  
      // 해당 <tr> 요소가 있으면 삭제
      if (trElement) {
        trElement.remove();
      }
      const trBong = document.getElementById('showBong');
      if (trBong) {
        trBong.remove();
      }


      this.currentShowChart = '';

      let selectSymbol = selectId.replace('KRW-','')+'USDT';
      const referenceTr = document.getElementById(selectId);
      let a = `<tr id="showBong">
              <th scope="row" colspan="7">
                <div>
                  <table style="width:100%;border-collapse: collapse;">
                    <tr>
                      <td id="bong1" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">1분</td>
                      <td id="bong5" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">5분</td>
                      <td id="bong15" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">15분</td>
                      <td id="bong1H" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">1시간</td>
                      <td id="bong4H" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">4시간</td>
                      <td id="bong1D" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">1일</td>
                      <td id="bong1W" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">1주</td>
                      <td id="bong1M" style="border: 1px solid #60666b;font-size:0.8rem;width:12.5%">1달</td>
                    </tr>
                  </table>
                </div>
              </th>
            </tr>`;
      // 새로운 <tr> 요소 생성
      const newTr = a+'<tr id="showChart"><th scope="row" colspan="7"><div id="tradingviewContainer"></div></th></tr>';
      this.symbol = selectSymbol;
      this.initializeTradingView();
      // id="a" 뒤에 새로운 <tr> 추가
      referenceTr.insertAdjacentHTML('afterend', newTr);
       this.$nextTick(() => {
        var element = document.getElementById('bong'+this.selectBong);
        element.style.backgroundColor = '#A6A6A6';
        this.$forceUpdate();  // Vue의 상태를 강제로 갱신
         const newRow = this.$el.querySelector('#bong1');
          newRow.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
            Cookies.set('selectBong', '1', { expires: 3650 });
            this.selectBong = '1';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow2 = this.$el.querySelector('#bong5');
          newRow2.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
            Cookies.set('selectBong', '5', { expires: 3650 });
            this.selectBong = '5';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow3 = this.$el.querySelector('#bong15');
          newRow3.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
            Cookies.set('selectBong', '15', { expires: 3650 });
            this.selectBong = '15';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow4 = this.$el.querySelector('#bong1H');
          newRow4.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
            Cookies.set('selectBong', '1H', { expires: 3650 });
            this.selectBong = '1H';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow5 = this.$el.querySelector('#bong4H');
          newRow5.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
            Cookies.set('selectBong', '4H', { expires: 3650 });
            this.selectBong = '4H';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow6 = this.$el.querySelector('#bong1D');
          newRow6.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
             Cookies.set('selectBong', '1D', { expires: 3650 });
            this.selectBong = '1D';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow7 = this.$el.querySelector('#bong1W');
          newRow7.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
             Cookies.set('selectBong', '1W', { expires: 3650 });
            this.selectBong = '1W';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
         const newRow8 = this.$el.querySelector('#bong1M');
          newRow8.addEventListener('click', () => {
            var element0 = document.getElementById('bong'+this.selectBong);
            element0.style.backgroundColor = '';
              Cookies.set('selectBong', '1M', { expires: 3650 });
            this.selectBong = '1M';
            var element = document.getElementById('bong'+this.selectBong);
            element.style.backgroundColor = '#A6A6A6';
            this.initializeTradingView();
         });
       });
      this.currentShowChart = selectId;
    },
    initializeTradingView() {
      // DOM 업데이트가 완료된 후 실행
      nextTick().then(() => {
        let symbolTxt = this.symbol;
        if(symbolTxt === 'USDTUSDT'){
          symbolTxt = 'USDTKRW';
        }
        if (window.TradingView) {
          new window.TradingView.widget({
            container_id: "tradingviewContainer", // DOM 참조
            width: "100%", // 차트의 너비
            height: "450px", // 차트의 높이
            symbol: symbolTxt,
            interval: this.selectBong,
            timezone: "Asia/Seoul",
            theme: "light",
            style: "1", // 캔들 차트 스타일
            locale: "ko",
          });
        } else {
          console.error("TradingView script is not loaded.");
        }
      });
    }
  },
  mounted() {
    //this.initializeTradingView();
    this.setExchange();
    this.initIndexChart();
    this.getUpbitSymbol();
    this.selectBong = Cookies.get('selectBong') || '1D';
    this.firstVisit = Cookies.get('firstVisit');
    this.fontSize = localStorage.getItem('fontSize') || 0.75;
    if(this.firstVisit !== 'N'){
      Cookies.set('KRW-BTC', "Y", { expires: 3650 });
      Cookies.set('KRW-ETH', "Y", { expires: 3650 });
      Cookies.set('KRW-XRP', "Y", { expires: 3650 });
      Cookies.set('KRW-SOL', "Y", { expires: 3650 });
      Cookies.set('KRW-DOGE', "Y", { expires: 3650 });
      Cookies.set('KRW-ADA', "Y", { expires: 3650 });
      Cookies.set('BTC.D_chart', "Y", { expires: 3650 });
      Cookies.set('ETH.D_chart', "Y", { expires: 3650 });
      Cookies.set('BTC1!_chart', "Y", { expires: 3650 });

      localStorage.setItem('indexChartList', JSON.stringify(this.indexChartList));

      this.initIndexChart();
    }else{
//    localStorage.setItem('indexChartList', JSON.stringify(this.indexChartList));
      this.indexChartList = JSON.parse(localStorage.getItem('indexChartList')) || this.indexChartList;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* - 버튼 */

.minus {
  font-size:0.75rem;
  border: 2px solid #60666b;
  margin-bottom:2px;
}
/* + 버튼 */
.plus {
  font-size:0.75rem;
  border: 2px solid #60666b;
  margin-right:10px;
  margin-left:3px;
  margin-bottom:2px;

}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.fs-4 {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  align-items: center;
  align-content: space-between;
  justify-content: center;
}
.align-left{
  text-align: left;
  font-size: 0.75rem;
  vertical-align: middle;
  white-space: nowrap;
}
.align-right{
  text-align: right;
  font-size: var(--font-size, 0.75rem);
  vertical-align: middle;
  white-space: nowrap;
}
.mob_active{
  font-weight: bold;
  color:#60666b;
}
.p0{  
    padding: 0.3rem 0 0.3rem 0;
}
.bongStyle{
  border: 1px solid #60666b;font-size:0.8rem;
}
.bongSelect{
  background-color: #A6A6A6;
}
.index-search {
  width:100%;
  border:var(--bs-border-width) solid var(--bs-highlight-color);
}
.btn-outline-dark {
    --bs-btn-color: #000;;
    --bs-btn-border-color: #60666b;;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #60666b;;
    --bs-btn-hover-border-color: #60666b;;
    --bs-btn-focus-shadow-rgb: 33, 37, 41;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #60666b;;
    --bs-btn-active-border-color: #60666b;;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #60666b;;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #60666b;;
    --bs-gradient: none;
}
.nav-pills {
    --bs-nav-pills-border-radius: var(--bs-border-radius);
    --bs-nav-pills-link-active-color: #fff;
    --bs-nav-pills-link-active-bg: #60666b;
}
.nav {
    --bs-nav-link-padding-x: 1rem;
    --bs-nav-link-padding-y: 0.5rem;
    --bs-nav-link-font-weight: ;
    --bs-nav-link-color: #60666b;
    --bs-nav-link-hover-color: #60666b;
    --bs-nav-link-disabled-color: var(--bs-secondary-color);
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}
.cursor-pointer{
   cursor: pointer;
}
.info-bar {
    background-color: black;
    color: white;
    text-align: center;
    padding: 10px 0;
    font-size: 16px;
    position: sticky;
    top: 0;
    z-index: 1020; /* 네비게이션 바 위에 배치 */
}

/* 내용이 가려지지 않도록 패딩 추가 */
.row {
    padding-top: 30px; /* 네비게이션 바 + 정보 바 높이만큼 여백 */
}
.navbar-toggler {
  width: 25px;
  height: 22px;
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.navbar-toggler span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #adb5bd;
  border-radius: 2px;
  transition: all 0.3s ease-in-out;
}
.btn-xs {
  padding: 0.25rem 0.5rem; /* 패딩 크기를 더 작게 설정 */
  font-size: 0.75rem; /* 폰트 크기 더 작게 설정 */
  line-height: 1.25; /* 줄 높이 조정 */
}
</style>
